export default import.meta.ROLLDOWN_FILE_URL_vMcrHKxNOSDQ6QJD11tlxA